import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  wrapper: {
    pointerEvents: 'none',
    backgroundColor: 'white',
    padding: '5px',
    width: '200px',
    border: '1px solid black',
    borderRadius: '5px'
  },
  title: {
    textAlign: 'center',
    fontWeight: 'bold'
  },
  line: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  date: {
    'text-align': 'center',
    color: 'slategray',
    margin: '0px 1px',
    fontSize: 10
  },
  loadedDate: {
    color: 'slategray',
    display: 'flex',
    paddingTop: 10,
    justifyContent: 'space-between'
  },
  divider: {
    margin: '3px 0'
  }
});

const CensusTractSummaryOverlay = ({ ctMouseoverData, classes }) => {
  const { GeoName } = ctMouseoverData;
  const ctArray = [
    {name: 'Population', value: 'Population', type: 'text'},
    {name: 'Date', value: 'PopulationDate', type: 'date'},
    {name: 'Owner %', value: 'OwnerOccupiedPctSFDetached', type: 'decimal'},
    {name: 'Rent %', value: 'RenterOccupiedPctSFDetached', type: 'decimal'},
    {name: 'Vacant %', value: 'VacantPctSFDetached', type: 'decimal'},
    {name: 'Med Rent', value: 'MedianRent', type: 'currency'},
    {name: 'Date', value: 'HousingDate', type: 'date'},
    {name: 'Med Home Value', value: 'MedianAvmValue', type: 'currency'},
    {name: 'Date', value: 'AvmValueDate', type: 'date'},
    // {name: 'Crime Index', value: 'CrimeIndex', type: 'decimal'},
    // {name: 'Wealth', value: 'Wealth', type: 'decimal'},
    // {name: 'Date', value: 'CrimeWealthDate', type: 'date'},
    {name: 'HPA 6mo', value: 'HPA6Mo', type: 'percent'},
    {name: 'HPA 12mo', value: 'HPA1Yr', type: 'percent'},
    {name: 'HPA 24mo', value: 'HPA2Yr', type: 'percent'},
    {name: 'Date', value: 'HPADate', type: 'date'},
    {name: 'AMI', value: 'AmherstEstimatedAMI', type: 'currency'},
    {name: 'Date', value: 'AmherstEstimatedAMIDate', type: 'date'},
    // {name: 'Transaction Price', value: 'transactionPrice', type: 'currency'},
    // {name: 'Transaction Count', value: 'transactionsCount', type: 'text'},
    {name: 'Affordable Pmt', value: 'AffordabilityPmt', type: 'currency'},
    {name: 'Affordability Price', value: 'AffordabilityPrice', type: 'currency'},
    {name: 'Affordability Score', value: 'AffordabilityScore', type: 'decimal'},
    {name: 'Opportunity Zone', value: 'IsInOpportunityZone', type: 'text'}
  ];
  const getText = (schema, value) => {
    switch(schema.type) {
      case 'percent':
        return value.toLocaleString(undefined, { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 });
      case 'decimal':
        return value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      case 'date':
        let newDate = new Date(value);
        return newDate.toLocaleDateString();
      case 'currency':
        return '$' + value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      default:
        return value.toLocaleString();
    }
  };
  let loadedDate = ctMouseoverData['CreateTimeStamp'] ? (new Date(ctMouseoverData['CreateTimeStamp'])).toLocaleDateString() : 'N/A';
  return (
    <div className={classes.wrapper}>
      <div className={classes.title}>
        {GeoName}
      </div>
      <hr></hr>
      {ctArray.map((data) => {
        return (
          (data.type !== 'date') ?
          
          <div className={classes.line} key={data.value}>
            <div>
              {data.name}
            </div>
            <div>
              {ctMouseoverData[data.value] ? getText(data, ctMouseoverData[data.value]) : 'N/A'}
            </div>
          </div> :
          <>
            <div className={classes.date} key={data.value}>
              {ctMouseoverData[data.value] ? getText(data, ctMouseoverData[data.value]) : 'N/A'}
            </div>
            <hr className={classes.divider}></hr>
          </>
        )
      })}
      <div className={classes.loadedDate}>
        <div>
          Loaded As Of
        </div>
        <div>
          {loadedDate}
        </div>
      </div>
    </div>
  )
};

export default withStyles(styles)(CensusTractSummaryOverlay);